module.exports = __webpack_public_path__ + "img/menu-selected.e3094c37.svg";